// Symptom→diagnosis matrix: deterministic ICD suggestions attached to an answer
// option in the form builder and surfaced on-device when the RN selects that
// option (no LLM). Authored once; static reference config shared across all
// visits, served via the cached /diagnosis-map endpoint.
/** Rank order for sorting suggestions High→Low. */
export const CONFIDENCE_RANK = {
    High: 0,
    Medium: 1,
    Low: 2
};
//# sourceMappingURL=diagnosis-matrix.js.map